import React from 'react';
import {
  Box, Skeleton, alpha, useTheme,
} from '@mui/material';

const DisclamerSectionSkeleton = () => {
  const theme = useTheme();

  return (
    <Box
      p={2}
      my={3}
      border={`1px solid ${alpha(theme.palette.common.white, 0.12)}`}
      borderRadius={2}
      display="flex"
      alignItems="flex-start"
      gap="8px">
      <Skeleton variant="text" height="30px" width="30px" />
      <Box flexGrow="1">
        <Skeleton variant="text" width="90%" height={30} />
        <Skeleton variant="text" width="100%" height={100} />
        <Skeleton variant="text" width="20%" height={30} />
      </Box>
    </Box>
  );
};

export { DisclamerSectionSkeleton };
